// src/components/Cart.js
import React from "react";
import { useCart } from "../context/cartContext";

const Cart = ({ products }) => {
  const { cartItems, removeFromCart, clearCart, loading } = useCart();

  if (loading) return <p className="p-4">Loading cart...</p>;

  if (cartItems.length === 0) return <p className="p-4">Your cart is empty</p>;

  // Calculate total sum based on products and quantities
  const total = cartItems.reduce((acc, cartItem) => {
    const product = products.find((p) => p.id === cartItem.id);
    if (!product) return acc; // product may have been removed
    return acc + product.price * cartItem.quantity;
  }, 0);

  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      <h2 className="text-xl font-bold mb-4">Your Order</h2>
      {cartItems.map(({ id, quantity }, index) => {
        const product = products.find((p) => p.id === id);
        const key = id || `fallback-${index}`; // ensure uniqueness

        if (!product) {
          return (
            <div key={key} className="py-2 border-b text-red-500">
              Product with ID {id || "???"} not found
              <button
                onClick={() => removeFromCart(id)}
                className="ml-2 text-red-700 font-bold"
              >
                Remove
              </button>
            </div>
          );
        }

        return (
          <div
            key={key}
            className="flex justify-between items-center border-b py-2"
          >
            <div>
              <p className="font-medium">{product.title}</p>
              <p className="text-sm text-gray-500">Quantity: {quantity}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-semibold">{product.price * quantity}€</span>
              <button onClick={() => removeFromCart(id)} className="text-red-500">
                &#10006;
              </button>
            </div>
          </div>
        );
      })}

      <div className="mt-4 text-right font-bold">Total: {total}€</div>
      <button
        onClick={clearCart}
        className="mt-2 text-sm text-gray-500 underline"
      >
        Clear cart
      </button>
    </div>
  );
};

export default Cart;
